
import { ActionType } from '../actionTypes';
import { Action } from '../actions/flippingFlyerActions';
import {ErrorDto, FileDto, FlyerDto, flyerDtoInitialState, SuccessDto} from "../../dtos";


export interface FlippingFlyerState {

    flyerDto?: FlyerDto;

    uploadLogo?: FileDto;
    hasUploadLogo?: boolean;

    pageSpotsFile?: FileDto;
    promotionDataFile?: FileDto;
    itemsDataFile?: FileDto;

    isFlyerHasBeenPublished?: boolean;
    hasFlyerPages?: boolean;

    loading: boolean;
    error?: ErrorDto | null;
    type: string | null;
    successInfo?: SuccessDto | null;
}

export class FlippingFlyerInitialState implements FlippingFlyerState {

    flyerDto = { ...flyerDtoInitialState };

    uploadLogo = { label: '', file: null };
    hasUploadLogo = false;

    pageSpotsFile = { label: '', file: null };
    promotionDataFile = { label: '', file: null };
    itemsDataFile = { label: '', file: null };

    hasFlyerPages = false;

    loading = true;
    error = null;
    type = null;
    successInfo = null;
}

const initialState = new FlippingFlyerInitialState();

const reducer = (state: FlippingFlyerState = initialState, action: Action): FlippingFlyerState => {

    switch (action.type) {

        //
        // case ActionType.RESET_FLYER_STATE:
        //     return { ...initialState };

        //
        case ActionType.GET_FLIPPING_FLYER_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.GET_FLIPPING_FLYER_SUCCESS: {

            state.uploadLogo!.label = action.payload.flyerDto?.flyImage!;
            action.payload.flyerDto!.deletedFlyerPages = [];

            return { ...state, ...action.payload, error: null, loading: false, type: action.type };
        }

        case ActionType.CLEAR_DATA_FROM_FLYER: {
            return { ...initialState, type: action.type };
        }

        case ActionType.GET_FLIPPING_FLYER_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };

        case ActionType.GET_FLIPPING_FLYER_COMPLETED:
            return { ...state, error: null, loading: false, type: action.type };

        //
        case ActionType.FLIPPING_FLYER_DATA_CHANGE_EVENT:
            return { ...state, ...action.payload, error: null, loading: false, type: action.type, successInfo: null }
        //
        case ActionType.POST_FLIPPING_FLYER_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.POST_FLIPPING_FLYER_SUCCESS: {

            action.payload.flyerDto!.deletedFlyerPages = [];
            state.uploadLogo!.label = action.payload.flyerDto?.flyImage!;

            return { ...state, ...action.payload, error: null, loading: false, type: action.type };
        }

        case ActionType.POST_FLIPPING_FLYER_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };

        case ActionType.POST_FLIPPING_FLYER_COMPLETED:
            return { ...state, error: null, loading: false, type: action.type };


        // spots xls file
        case ActionType.POST_FLYER_SPOTS_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.POST_FLYER_SPOTS_SUCCESS: {
            return { ...state, flyerDto: { ...action.payload.flyer }, error: null, loading: false, type: action.type, successInfo: {...action.payload.successInfo} };
        }

        case ActionType.POST_FLYER_SPOTS_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };

        case ActionType.POST_FLYER_SPOTS_COMPLETED:
            return { ...state, error: null, loading: false, type: action.type };

        // get frames xls file
        case ActionType.GET_CURRENT_DATA_FRAMES_FOR_FLYER_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.GET_CURRENT_DATA_FRAMES_FOR_FLYER_SUCCESS: {
            return { ...state, error: null, loading: false, type: action.type };
        }

        case ActionType.GET_CURRENT_DATA_FRAMES_FOR_FLYER_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };

        case ActionType.GET_CURRENT_DATA_FRAMES_FOR_FLYER_COMPLETE:
            return { ...state, error: null, loading: false, type: action.type };

        // promos xls file
        case ActionType.POST_FLYER_PROMOS_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.POST_FLYER_PROMOS_SUCCESS: {
            return { ...state, flyerDto: { ...action.payload }, error: null, loading: false, type: action.type };
        }

        case ActionType.POST_FLYER_PROMOS_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };

        case ActionType.POST_FLYER_PROMOS_COMPLETED:
            return { ...state, error: null, loading: false, type: action.type };
        // promos and items xls file
        case ActionType.POST_FLYER_PROMOS_AND_ITEMS_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.POST_FLYER_PROMOS_AND_ITEMS_SUCCESS: {
            return { ...state, flyerDto: { ...action.payload.flyer }, error: null, loading: false, type: action.type, successInfo: {...action.payload.successInfo} };
        }

        case ActionType.POST_FLYER_PROMOS_AND_ITEMS_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };

        case ActionType.POST_FLYER_PROMOS_AND_ITEMS_COMPLETED:
            return { ...state, error: null, loading: false, type: action.type };
        // empty excel for promos and items xls file
        case ActionType.GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null};
        case ActionType.GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_SUCCESS:
            return { ...state, error: null, loading: false, type: action.type };
        case ActionType.GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };
        case ActionType.GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_COMPLETE:
            return { ...state, error: null, loading: false, type: action.type };
        // empty excel for promos and items xls file
        case ActionType.GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };
        case ActionType.GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_SUCCESS:
            return { ...state, error: null, loading: false, type: action.type };
        case ActionType.GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };
        case ActionType.GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_COMPLETE:
            return { ...state, error: null, loading: false, type: action.type };
        // images for promos items xls file
        case ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_SUCCESS: {
            return { ...state, flyerDto: { ...action.payload }, error: null, loading: false, type: action.type };
        }

        case ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };

        case ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_COMPLETE:
            return { ...state, error: null, loading: false, type: action.type };

        // images for promos files
        case ActionType.POST_IMAGES_FOR_PROMOTIONS_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.POST_IMAGES_FOR_PROMOTIONS_SUCCESS: {
            return { ...state, error: null, loading: false, type: action.type, successInfo: {...action.payload.successInfo} };
        }
        case ActionType.POST_IMAGES_FOR_PROMOTIONS_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };
        case ActionType.POST_IMAGES_FOR_PROMOTIONS_COMPLETE:
            return { ...state, error: null, loading: false, type: action.type };

        // images for items files
        case ActionType.POST_IMAGES_FOR_ITEMS_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.POST_IMAGES_FOR_ITEMS_SUCCESS: {
            return { ...state, error: null, loading: false, type: action.type, successInfo: {...action.payload.successInfo} };
        }
        case ActionType.POST_IMAGES_FOR_ITEMS_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };

        case ActionType.POST_IMAGES_FOR_ITEMS_COMPLETE:
            return { ...state, error: null, loading: false, type: action.type };

        // promo items xls file
        case ActionType.POST_FLYER_PROMOITEMS_START:
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };

        case ActionType.POST_FLYER_PROMOITEMS_SUCCESS: {
            return { ...state, flyerDto: { ...action.payload }, error: null, loading: false, type: action.type };
        }

        case ActionType.POST_FLYER_PROMOITEMS_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };

        case ActionType.POST_FLYER_PROMOITEMS_COMPLETED:
            return { ...state, error: null, loading: false, type: action.type };

        // the default switch case must be included as followed:
        default:
            return state;
    }

}

export default reducer;